import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { ShippingPanel } from "@/components/admin/shipping/ShippingPanel";

export const Route = createFileRoute("/_authenticated/admin/shipping")({
  head: () => ({
    meta: [
      { title: "Админ — Доставка | FIXHEN" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <AdminLayout>
      <ShippingPanel />
    </AdminLayout>
  ),
});